import { ShoppingBagIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const BasketSearch = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ShoppingBagIcon {...rest} size={Sizes[size]} color={fill} />;
};

BasketSearch.displayName = 'BasketSearch';
